import { del, get, patch, post } from './api'
import { EndUser, Company } from '@/types'

export interface PaginatedCompanies {
	count: number
	rows: Company[]
}

export function getEndUsersSummary(id: number, pending: boolean): Promise<EndUser[]> {
	const url = `/api/companies/end-users?partner_id=${id}&rows=100`
	return get(url + (pending ? '&pending=1' : ''))
}

export function getDistributors(): Promise<EndUser[]> {
	return get(`/api/companies?role=2&rows=100`).then(result => result.rows)
}

export function getResellers(distributorId?: number): Promise<EndUser[]> {
	if (!distributorId) {
		return get(`/api/companies?role=3&rows=100`).then(result => result.rows)
	}
	return get(`/api/companies?role=3&parent_id=${distributorId}&rows=100`).then(result => result.rows)
}

export function getEndUsers(resellerId: number): Promise<EndUser[]> {
	return get(`/api/companies?role=4&parent_id=${resellerId}&rows=100`).then(result => result.rows)
}
export function getAllEndUsers(): Promise<EndUser[]> {
	return get(`/api/companies?role=4&rows=1000`).then(result => result.rows)
}

export function getAll(onlyApproved = false): Promise<Company[]> {
	const params = onlyApproved ? '&approved=1' : ''
	return get(`/api/companies?rows=1000${params}`).then(result => result.rows)
}

export function list(filters: any = {}, page = 1, rows = 10): Promise<PaginatedCompanies> {
	let url = `/api/companies?page=${page}&rows=${rows}`
	if (filters.name) url += `&name=${filters.name}`
	if (filters.role) url += `&role=${filters.role}`
	if (filters.unapproved) url += '&unapproved=1'
	if (filters.sortBy) url += `&sort_by=${filters.sortBy}`
	if (filters.sortDesc) url += `&sort_desc`
	return get(url)
}

export function addCompany(data: any) {
	return post('/api/companies', data)
}

export function getById(id: number) {
	return get(`/api/companies/${id}`)
}

export function updateCompany(company: Company) {
	return patch(`/api/companies/${company.id}`, company)
}

export function remove(id: number) {
	return del(`/api/companies/${id}`)
}

export function getTree() {
	return get('/api/companies/tree')
}
